/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionRef,
  JpClassSectionRefOptional,
  JpClassSectionRefMetaI,
  JpClassSectionRefTrackedI,
} from "./jp-class-section-ref";
import {
  JpClassSectionRefTracked,
  JpClassSectionRefMeta,
} from "./jp-class-section-ref";

/**
 *
 * @export
 * @interface WithSections
 */
export interface WithSectionsOptional {
  /**
   *
   * @type {Array<JpClassSectionRef>}
   * @memberof WithSections
   */
  sections?: JpClassSectionRefOptional[];
}

export interface WithSections extends WithSectionsOptional {
  /**
   *
   * @type {Array<JpClassSectionRef>}
   * @memberof WithSections
   */
  sections?: JpClassSectionRef[];
}

export interface WithSectionsTrackedI {
  /**
   *
   * @type {Array<JpClassSectionRef>}
   * @memberof WithSections
   */
  sections?: JpClassSectionRefTrackedI[];
  sectionsIsSet: boolean;
}

transformDatesMap.set("WithSections", function (model: WithSections) {
  const transformDatessections = transformDatesMap.get("JpClassSectionRef");
  if (transformDatessections) {
    model.sections?.forEach((sub) => {
      transformDatessections(sub);
    });
  }
});

export type WithSectionsMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sections: PropertyMeta<JpClassSectionRefMetaI>;
}>;

export var WithSectionsMeta: WithSectionsMetaI = {} as WithSectionsMetaI;
WithSectionsMeta = typeMeta("WithSections", {
  sections: propertyMeta("sections", true, false, false, JpClassSectionRefMeta),
});

const metaI = WithSectionsMeta;

registerMeta(() => {});

export class WithSectionsTracked implements WithSectionsTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sections__I?: JpClassSectionRefTracked[] = undefined;
  sectionsIsSet: boolean = false;
  set sections(v: undefined | JpClassSectionRefTracked[]) {
    if (v !== undefined) {
      this.sections__I = v;
      this.sectionsIsSet = true;
    } else {
      this.sections__I = v || undefined;
      this.sectionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get sections() {
    return this.sections__I;
  }
  constructor(config?: WithSectionsOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.sections?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: WithSectionsOptional,
    options?: AssignOptions,
  ): WithSectionsTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.sections && this.sectionsApplyFilter(optionsRequired.filter)) {
      this.sections = config.sections?.map(
        (a) => new JpClassSectionRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.sectionsIsSet = false;
      else this.sectionsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithSectionsTrackedI {
    const cloned = {} as WithSectionsTrackedI;
    if (
      this.sectionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.sectionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionsIsSet = true;
      cloned.sections = this.sections
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.sectionsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithSectionsTrackedI {
    if (!this.sectionsApplyFilter(filter)) this.sectionsIsSet = false;

    this.sections?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  sectionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithSectionsMeta.sections,
      WithSectionsMeta,
      this.sections,
      this,
    );
  }
  sectionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionsIsSet && this.sectionsApplyFilter(filter)) return true;

    return this.sections?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sectionsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
